import { CloseButton, Flex } from '@chakra-ui/react';
import { ReactElement, useState } from 'react';
import { isMaintenance } from '../../../config';

const AppBanner = (): ReactElement | null => {
  const [visible, setVisible] = useState(isMaintenance);

  if (!visible) return null;
  return (
    <Flex
      position="fixed"
      justify="center"
      align="center"
      w="full"
      p={3}
      top={0}
      left={0}
      bg="gray.1000"
      color="white"
      textAlign="center"
      fontWeight="bold"
      fontSize="sm"
      zIndex="sticky"
    >
      <p>
        We&apos;re currently implementing important system upgrades. There may be brief hiccups, but
        we&apos;ll be fully operational soon.
      </p>
      <CloseButton
        position="absolute"
        right={0}
        size="sm"
        onClick={() => setVisible(false)}
        mr={3}
      />
    </Flex>
  );
};
export default AppBanner;
